<template lang="">
    <div>
        <h1 class="font-bold">{{title}}</h1>
        <input class="mt-1 form-select border border-gray-300 bg-gray-300 text-500 rounded-2xl w-full pointer-events-none" :placeholder="placeholder">
    </div>
</template>
<script>
export default {
    props: {
        title: String,
        placeholder: String
    }
}
</script>
